/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface DiscountData
 */
export interface DiscountData {
    /**
     * 
     * @type {string}
     * @memberof DiscountData
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountData
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscountData
     */
    amountNet?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscountData
     */
    amountGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof DiscountData
     */
    turnoverNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof DiscountData
     */
    turnoverGross?: MoneyOutput;
}

/**
 * Check if a given object implements the DiscountData interface.
 */
export function instanceOfDiscountData(value: object): value is DiscountData {
    return true;
}

export function DiscountDataFromJSON(json: any): DiscountData {
    return DiscountDataFromJSONTyped(json, false);
}

export function DiscountDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscountData {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'amountNet': json['amountNet'] == null ? undefined : json['amountNet'],
        'amountGross': json['amountGross'] == null ? undefined : json['amountGross'],
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['turnoverGross']),
    };
}

export function DiscountDataToJSON(json: any): DiscountData {
    return DiscountDataToJSONTyped(json, false);
}

export function DiscountDataToJSONTyped(value?: DiscountData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'amountNet': value['amountNet'],
        'amountGross': value['amountGross'],
        'turnoverNet': MoneyOutputToJSON(value['turnoverNet']),
        'turnoverGross': MoneyOutputToJSON(value['turnoverGross']),
    };
}

